<template>
  <div class="sidebar-filtros-bi d-flex flex-column h-100" :style="{ width: larguraSidebar + 'px' }">
    <div class="sidebar-search p-2 border-bottom">
      <div class="input-group input-group-sm">
        <span class="input-group-text sidebar-search-icon">
          <i class="bi bi-search"></i>
        </span>
        <input
          v-model="buscaGlobal"
          type="text"
          class="form-control form-control-sm sidebar-search-input"
          placeholder="Buscar em todos os filtros..."
        />
      </div>
    </div>

    <div class="sidebar-slicers flex-grow-1 overflow-auto p-2">
      <SlicerDimensao
        v-for="slicer in slicersConfig"
        :key="slicer.chave"
        :titulo="slicer.titulo"
        :icone="slicer.icone"
        :opcoes="filtrarOpcoesPorBusca(slicer.chave)"
        :ids-selecionados="filtros[slicer.chave] || []"
        :loading="loadingStates[slicer.chave] || false"
        :max-visiveis="slicer.maxVisiveis || 5"
        @update:idsSelecionados="(val) => atualizarFiltro(slicer.chave, val)"
      />
    </div>

    <div class="sidebar-footer p-2 border-top">
      <button class="btn btn-outline-secondary btn-sm w-100 sidebar-avancados-btn" @click="$emit('abrir-avancados')">
        <i class="bi bi-sliders me-1"></i> Filtros Avançados
      </button>
    </div>

    <!-- Alça de redimensionamento -->
    <div
      class="sidebar-resize-handle"
      @mousedown.prevent="iniciarRedimensionamento"
    ></div>
  </div>
</template>

<script setup>
import SlicerDimensao from './SlicerDimensao.vue'

import { ref, onUnmounted } from 'vue'

const props = defineProps({
  slicersConfig: { type: Array, required: true },
  filtros: { type: Object, default: () => ({}) },
  opcoesPorDimensao: { type: Object, default: () => ({}) },
  loadingStates: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['update:filtros', 'abrir-avancados'])

const buscaGlobal = ref('')

const LARGURA_MIN = 200
const LARGURA_MAX = 600
const larguraSidebar = ref(300)

function filtrarOpcoesPorBusca (chave) {
  const opcoes = props.opcoesPorDimensao[chave] || []
  if (!buscaGlobal.value) return opcoes
  const termo = buscaGlobal.value.toLowerCase()
  return opcoes.filter(o =>
    o.rotulo?.toLowerCase().includes(termo) ||
    o.complemento?.toLowerCase().includes(termo)
  )
}

function atualizarFiltro (chave, valor) {
  const novosFiltros = { ...props.filtros, [chave]: valor }
  emit('update:filtros', novosFiltros)
}

// ── Redimensionamento por arrasto ──
let resizeStartX = 0
let resizeStartWidth = 0

function iniciarRedimensionamento (event) {
  resizeStartX = event.clientX
  resizeStartWidth = larguraSidebar.value
  document.addEventListener('mousemove', redimensionar)
  document.addEventListener('mouseup', finalizarRedimensionamento)
  document.documentElement.style.userSelect = 'none'
  document.documentElement.style.cursor = 'col-resize'
}

function redimensionar (event) {
  const delta = event.clientX - resizeStartX
  const nova = Math.min(LARGURA_MAX, Math.max(LARGURA_MIN, resizeStartWidth + delta))
  larguraSidebar.value = nova
}

function finalizarRedimensionamento () {
  document.removeEventListener('mousemove', redimensionar)
  document.removeEventListener('mouseup', finalizarRedimensionamento)
  document.documentElement.style.userSelect = ''
  document.documentElement.style.cursor = ''
}

onUnmounted(() => {
  finalizarRedimensionamento()
})
</script>

<style scoped>
.sidebar-filtros-bi {
  --sidebar-bg: var(--bs-body-bg);
  --sidebar-border: var(--bs-border-color);
  --sidebar-search-bg: var(--bs-tertiary-bg);
  min-width: 200px;
  max-width: 600px;
  background: var(--sidebar-bg);
  position: relative;
  flex-shrink: 0;
}

.sidebar-search {
  border-color: var(--sidebar-border) !important;
}

.sidebar-search-icon {
  background: var(--sidebar-search-bg);
  border: none;
  color: var(--bs-secondary-color);
}

.sidebar-search-input {
  background: var(--sidebar-search-bg);
  border: none;
  color: var(--bs-body-color);
}

.sidebar-search-input::placeholder {
  color: var(--bs-secondary-color);
}

.sidebar-slicers::-webkit-scrollbar {
  width: 4px;
}

.sidebar-slicers::-webkit-scrollbar-thumb {
  background-color: var(--bs-border-color);
  border-radius: 4px;
}

.sidebar-avancados-btn {
  font-size: 0.8rem;
}

/* Alça de redimensionamento na borda direita */
.sidebar-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
  transition: background 0.15s;
  z-index: 10;
}

.sidebar-resize-handle:hover,
.sidebar-resize-handle:active {
  background: var(--bs-primary);
  opacity: 0.4;
}
</style>
